import { render, staticRenderFns } from "./form-treatment-selection.vue?vue&type=template&id=559f1b94"
import script from "./form-treatment-selection.vue?vue&type=script&lang=ts"
export * from "./form-treatment-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports